import { AveragePrepFqScores } from "../../../models/users";

export const getAsterisks = (amount: number) => {
  const white = { color: "white" }
  switch (amount) {
    case 1:
      return <div><span style={white}>**</span>*&thinsp;</div>;
    case 2:
      return <div><span style={white}>*</span>**&thinsp;</div>;
    case 3:
      return <div>***&thinsp;</div>;
    default:
      return <div style={white}>***&thinsp;</div>;
  }
}
export const getAsterisksPlainText = (amount: number) => {
  switch (amount) {
    case 1:
      return ` *`;
    case 2:
      return ` *`;
    case 3:
      return ` ***`;
    default:
      return ``;
  }
}
export const getRatingText = (scaled_score: number, average_score: AveragePrepFqScores) => {
  if (!average_score) {
    return "";
  } else if (scaled_score <= average_score.average_score) {
    return "prepFq:report.ratings.belowAverage"
  } else if (scaled_score <= average_score.best_score) {
    return "prepFq:report.ratings.belowBest"
  } else if (scaled_score <= 100) {
    return "prepFq:report.ratings.below100"
  }
}